import SideSheetDrawer from "../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../hooks/use-disclosure";
import UpsertPatientForm from "./UpsertPatientForm";
interface AddPatientDrawerProps {
  disclosureHost: DisclosureHost;
}
const AddPatientDrawer = ({ disclosureHost }: AddPatientDrawerProps) => {
  return (
    <SideSheetDrawer
      w={"60vw"}
      title="Add Patient"
      color="primary"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
    >
      <UpsertPatientForm onCancel={disclosureHost.close} disableScrollArea />
    </SideSheetDrawer>
  );
};

export default AddPatientDrawer;
